import React from "react";
import { makeStyles } from "tss-react/mui";

// core components
import Header from "../components/Header/Header.js";
import Footer from "../components/Footer/Footer.js";
import HeaderLinks from "../components/Header/HeaderLinks.js";
import Parallax from "../components/Parallax/Parallax.js";
import logo from "../public/img/logo.png";

import styles from "../styles/jss/nextjs-material-kit/pages/articleStyle.js";

// Sections for this page
import PreFooter from "../pages-sections/LandingPage-Sections/PreFooter.js";
import Head from "next/head";
import headerBg from "../public/img/faces/advice_main_bg.png";

const dashboardRoutes = [];

const useStyles = makeStyles()(styles);

export default function Custom404(props) {
  const { classes, cx } = useStyles();
  const { ...rest } = props;
  return (
    <div className={cx(classes.white_bg, "employers")}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        logo={logo}
        rightLinks={<HeaderLinks />}
        fixed
        {...rest}
      />
      <Head>
        <title>Not Found - Success at School</title>
      </Head>
      <Parallax className="parallaxx-compact" filter image={headerBg}>
        <div className={cx(classes.container)}>
          <h1 className={cx(classes.title, "title")}>Not Found</h1>
        </div>
      </Parallax>

      <div className={cx(classes.container)} style={{ padding: "40px 0" }}>
        <p>Sorry, that page could not be found</p>
      </div>

      <div className={cx(classes.darkBlue, "footer", "colored_bgg")}>
        <PreFooter />
      </div>
      <Footer />
    </div>
  );
}
